import { StreamActions } from '@hotwired/turbo'

StreamActions.redirect = function () {
  Turbo.visit(this.target, { action: 'replace' })
}

StreamActions.redirect_to = function () {
  Turbo.visit(this.target, { action: 'advance' })
}
